/**
 * The class list every question part shares in the three assessments.
 *
 * All three lay a question out as BANDS: each part of the question (framing,
 * question text, options) sits in its own grid row, and every step of the run
 * puts its own copy of that part in the same row. A row is then as tall as the
 * tallest instance of that part across the whole set, so the framing box, the
 * question and the first option each keep one fixed position for the length of
 * the run — the composition does not grow, shrink or slide as the reader goes
 * forward and back.
 *
 * The step that is not being shown stays in the layout (`invisible`, and
 * `inert` at the call site, so it is out of the tab order and away from screen
 * readers) — that is what holds the row open. The opacity pair on top of it
 * fades the incoming step in rather than swapping it hard; `visibility` flips
 * at once, `opacity` is what the eye follows.
 */
export function band(on: boolean): string {
  return (
    'col-start-1 transition-opacity [transition-duration:var(--transition-base)] ' +
    (on ? 'opacity-100' : 'invisible opacity-0')
  )
}
